import $vuetify from 'vuetify/es5/locale/zh-Hans'

export default {
	fileName: '文件名称',
	modifiedTime: '修改时间',
	fileSize: '文件大小',
	mainDrive: '主硬盘',
	search: '搜索',
	fileUpload: '上传文件',
	urlUpload: '从网址上传',
	upload: '上传',
	fileToUpload: '要上传的文件',
	uploading: '正在上传...',
	serverProcessing: '服务器正在处理文件',
	bigFileUploadWarning:
		'由于 CloudFlare Workers 的限制，上传大档案可能会随机失败',
	$vuetify,
}
